export interface cardsChartNormalizerProps {
  environmentIndicator: number;
  error: number;
  consumption: number;
  monthCost: number;
  monthIncome: number;
  coin: string;
  statusChargeBox: {
    total: number;
    available: number;
    charging: number;
    unavailable: number;
  };
  totalUsers: number;
  userChargingPercentage: number;
  usersCharged: number;
  usersRegistered: number;
  treePercentageGoal: number;
  cultivatedTree: number;
}

export interface NormalizerCardsChart {
  users: {
    total: number;
    inUse: number;
    notUsing: number;
    usersUsing?: number;
    usersTotal?: number;
    charged: number;
    registered: number;
  };
  stations: {
    inUse: number;
    available: number;
    total: number;
    unavailable: number;
    maintenance: number;
  };
  energy: {
    consumption: number;
    monthCost: number;
    monthIncome: number;
    coin: string;
  };
  co2Saved: number;
  treePercentageGoal: number;
  cultivatedTree: number;
}

export const cardsChartNormalizer = (
  data: cardsChartNormalizerProps | any,
): NormalizerCardsChart => {
  const inUse =
    (data?.statusChargeBox?.charging / data?.statusChargeBox?.total) * 100;
  const available =
    (data?.statusChargeBox?.available / data?.statusChargeBox?.total) * 100;
  const unavailable =
    (data?.statusChargeBox?.unavailable / data?.statusChargeBox?.total) * 100;
  const maintenance =
    (data?.statusChargeBox?.maintenance / data?.statusChargeBox?.total) * 100;

  return {
    users: {
      total: data?.totalUsers,
      inUse: data?.userChargingPercentage,
      notUsing: 100 - data?.userChargingPercentage,
      charged: data?.usersCharged,
      registered: data?.usersRegistered,
    },
    stations: {
      inUse,
      available,
      total: data?.statusChargeBox?.total,
      unavailable,
      maintenance,
    },
    energy: {
      consumption: data?.energy?.consumption || 0,
      monthCost: data?.cost || 0,
      monthIncome: data?.income || 0,
      coin: data?.coin,
    },
    co2Saved: data?.envIndicator,
    treePercentageGoal: data?.energy?.treePercentageGoal,
    cultivatedTree: data?.energy?.cultivatedTree,
  };
};
